import React from "react";
import { useNavigate } from "react-router-dom";
import "./Banner.css";
import { useLocalContext } from "../../context/LocalContext";
import { FaArrowRight, FaCheckCircle } from "react-icons/fa";

const Banner = () => {
  const navigate = useNavigate();
  const { webinfo = {} } = useLocalContext();

  return (
    <section className="ctaX">
      <div className="ctaX__wrap">
        {/* Left */}
        <div className="ctaX__left">
          <span className="ctaX__tag">Free Growth Audit</span>

          <h2 className="ctaX__title">
            Let’s find the <span>quick wins</span> holding back your leads.
          </h2>

          <p className="ctaX__sub">
            With <b>{webinfo.name}</b>, you get a practical action plan — what to fix,
            what to improve, and what to scale. We focus on conversion, speed,
            tracking, and follow-ups so your marketing becomes predictable.
          </p>

          <div className="ctaX__bullets">
            <div className="bItem">
              <FaCheckCircle /> Website + funnel review (CRO)
            </div>
            <div className="bItem">
              <FaCheckCircle /> Speed + SEO basics (quick wins)
            </div>
            <div className="bItem">
              <FaCheckCircle /> Tracking + lead follow-up suggestions
            </div>
          </div>

          <div className="ctaX__actions">
            <button
              className="ctaX__btn ctaX__btnPrimary"
              onClick={() => navigate("/contact")}
              type="button"
            >
              Get Free Audit <FaArrowRight />
            </button>

            <button
              className="ctaX__btn ctaX__btnGhost"
              onClick={() => navigate("/services")}
              type="button"
            >
              See Services
            </button>
          </div>

          <p className="ctaX__note">
            No spam. No pressure. Just a clear, prioritized plan.
          </p>
        </div>

        {/* Right */}
        <div className="ctaX__right">
          <div className="ctaX__kpis">
            <div className="kpi">
              <span className="k">Avg. uplift</span>
              <b>+20–35%</b>
              <span className="s">Conversion improvements</span>
            </div>
            <div className="kpi">
              <span className="k">Speed wins</span>
              <b>1–3s</b>
              <span className="s">Typical load time gain</span>
            </div>
            <div className="kpi">
              <span className="k">Lead quality</span>
              <b>Better in</b>
              <span className="s">2–4 weeks (with tracking)</span>
            </div>
          </div>

          <div className="ctaX__media">
            <img
              className="ctaX__img"
              src="https://res.cloudinary.com/ds6hr7isn/image/upload/v1750763836/new-product-launching-illustration-download-in-svg-png-gif-file-formats--launch-planning-release-management-pack-business-illustrations-5254146_gujcm2.png"
              alt="Growth illustration"
            />
          </div>
        </div>

        {/* Decorative */}
        <span className="ctaX__orb ctaX__orb1" />
        <span className="ctaX__orb ctaX__orb2" />
      </div>
    </section>
  );
};

export default Banner;